import React, { useState } from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

import useSettings from '@src/hooks/useSettings';
import useInvoiceFilters from '@src/hooks/useInvoiceFilters';
import useInvoicesListQuery from '@src/hooks/useInvoicesListQuery';
import Filters from '@src/components/shared/Filters';
import InvoicesTable, {
  InvoiceActionDropdown,
} from '@src/components/shared/InvoicesTable';
import Card from '@src/components/ui/Card';
import EmptyResults from '@src/components/shared/EmptyResults';
import { getPaginationValuesForQuery } from '@src/utils/pagination';

import { InvoiceVoucherType } from '@src/types/enums';

const TableCard = styled(Card)`
  padding: ${({ theme }) => theme.spacing[8]};
`;

function ArchivedInvoicesTable() {
  const limit = 50;
  const intl = useIntl();
  const { business, currentUser } = useSettings();
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [filters] = useInvoiceFilters({
    archived: true,
    voucherType: [InvoiceVoucherType.INVOICE],
  });
  const {
    loading,
    data: { invoices, totalAmount },
    count,
    next,
    hasNext,
    previous,
    hasPrevious,
    page,
    nodes,
  } = useInvoicesListQuery({
    ...filters,
    ...getPaginationValuesForQuery(filters, limit),
  });

  const clearSelection = () => {
    setSelectedIds([]);
  };

  return (
    <TableCard>
      <Filters fields={['invoicingDate', 'businessEmitterId', 'voucherType']} />
      <InvoicesTable
        columns={{
          id: 100,
          receiverCountryTaxPayerInfo: 100,
          voucherType: 100,
          invoicingDate: 200,
          businessEmitter: 300,
          total: 150,
          paymentStatus: 100,
        }}
        nodes={nodes}
        invoices={invoices}
        loading={loading}
        showActionBar
        selectedIds={selectedIds}
        onSelect={setSelectedIds}
        limit={limit}
        page={page}
        totalAmount={totalAmount}
        actions={
          <InvoiceActionDropdown
            invoiceIds={selectedIds}
            count={count}
            businessId={business?.id}
            userEmail={currentUser?.email}
            unarchivable
            payable
            onMarkAsPaid={clearSelection}
            onUnarchive={clearSelection}
          />
        }
        emptyElement={
          <EmptyResults
            label={intl.formatMessage({
              defaultMessage: 'Aún no tienes cuentas archivadas',
              id: 'O/Z2Dt',
            })}
            description={intl.formatMessage({
              defaultMessage:
                'Aquí verás todas las cuentas archivadas que tengas en Higo.',
              id: 'uOwcjE',
            })}
          />
        }
        count={count}
        onNext={next}
        hasNext={hasNext}
        onPrevious={previous}
        hasPrevious={hasPrevious}
        selectable
      />
    </TableCard>
  );
}

export default ArchivedInvoicesTable;
